module.exports = __webpack_public_path__ + "img/chinesecompany161.a019a039.png";